import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CargaZEList } from "./cargas/list";
import { GuiaList } from "./guias/list";

type Entity = models.ChoferZEDto;
interface Props {
    value?: Entity;
}

class AuxiliarChoferZENoRX extends React.PureComponent<Props> {

    value = (x: Props) => x.value;
    getField = formfields(() => this.props);

    render() {
        const getField = this.getField;
        const CargasLista = getField(CargaZEList);
        const GuiasList = getField(GuiaList);

        const value = this.value(this.props);

        return (
            <div>
                {
                    value ?
                        <div>
                            {
                                value.IdVehiculoZE ?
                                    <selectores.VehiculoZE value={value.IdVehiculoZE} label="Vehículo actualmente asignado" readonly /> :
                                    <div className="alert alert-info">
                                        <label>No tiene asignado ningún vehículo actualmente</label>
                                        <br />
                                    </div>
                            }
                            <div className="row">
                                <div className="col-md-12">
                                    <h4>
                                        <span>Guías en el vehículo</span>
                                    </h4>
                                </div>
                            </div>
                            <GuiasList field="GuiasEnVehiculoAsignado" />
                        </div>
                        : null
                }
            </div>
        )
    }
}

export const AuxiliarChofer = componentToRx(AuxiliarChoferZENoRX);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/resumenchoferze/list/componentes/auxiliarchofer.tsx